// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"300":"c68071d3","592":"c9f9f6e0","856":"5474412b","952":"cb9b3988"}[chunkId] + ".chunk.js";
};